import { Component, Element, h, Prop, getAssetPath, State } from '@stencil/core';

@Component({
  tag: 'pennlibs-footer',
  styleUrl: 'pennlibs-footer.css',
  shadow: true,
  assetsDirs: ['assets']
})
export class Footer {
  /**
   * The navigation sections.
   */
  @Prop() navigation: Array<{
    heading: string;
    links: Array<{
      label: string;
      href: string;
    }>;
  }>;

  @State() navigationByChildren;

  @Element() hostElement: HTMLElement;

  componentWillLoad() {
    this.setNavigationByChildren();
  }

  setNavigationByChildren() {
    try {
      if (this.hostElement.children) {
        this.navigationByChildren = Array.from(this.hostElement.children).reduce(
          (acc, element) => {
            acc = acc.concat({
              heading: element.querySelector('h2').innerText,
              links: Array.from(element.querySelectorAll('a')).map(link => {
                return { label: link.innerText, href: link.href }
              })
            })
  
            return acc;
          }, []);
      }
    } catch {
      console.warn('<pennlibs-footer> Composed with unexpected HTML', this.hostElement.children)
    }
  }

  render() {
    const footerBackgroundSrc = getAssetPath('./assets/footer-bg.png');
    
    return (
      <footer class="website-footer" style={{
        background: `var(--color-penn-blue) url(${footerBackgroundSrc}) no-repeat 50% 50%`,
        backgroundSize: 'cover',
      }}>
        <div class="viewport-margins">
          <div class="website-footer__content">
            <div class="website-footer__links-container">
              <section>
                <h2 class="website-footer__heading">University of Pennsylvania Libraries</h2>
                <ul class="website-footer__links">
                  <li><a href="https://maps.google.com/?q=Van Pelt Library 3420 Walnut Street, Philadelphia, PA 19104-6206">3420 Walnut Street<br />Philadelphia, PA 19104-6206</a></li>
                  <li><a href="tel:(215) 898-7555">(215) 898-7555</a></li>
                  <li><a href="https://faq.library.upenn.edu/ask">Ask us a question</a></li>
                  <li><a href="https://www.library.upenn.edu/about/hours" target="_blank">Locations and hours</a></li>
                </ul>
              </section>
              <section>
                <h2 class="website-footer__heading">Our Community</h2>
                <ul class="website-footer__links">
                  <li><a href="https://www.library.upenn.edu/staff">Staff directory</a></li>
                  <li><a href="https://www.instagram.com/upennlib/">Instagram</a></li>
                  <li><a href="https://www.facebook.com/PennLibraries/">Facebook</a></li>
                  <li><a href="https://twitter.com/upennlib">Twitter</a></li>
                  <li><a href="https://www.linkedin.com/company/penn-libraries">LinkedIn</a></li>
                </ul>
              </section>
              {this.navigationByChildren && [
                this.navigationByChildren.map(section => (
                  <section>
                    <h2 class="website-footer__heading">{section.heading}</h2>
                    <ul class="website-footer__links">
                      {section.links.map(link => (
                        <li><a href={link.href}>{link.label}</a></li>
                      ))}
                    </ul>
                  </section>
                ))
              ]}
              {this.navigation && [
                this.navigation.map(section => (
                  <section>
                    <h2 class="website-footer__heading">{section.heading}</h2>
                    <ul class="website-footer__links">
                      {section.links.map(link => (
                        <li><a href={link.href}>{link.label}</a></li>
                      ))}
                    </ul>
                  </section>
                ))
              ]}
            </div>
          </div>
        </div>
        <div class="website-footer__footer">
          <div class="viewport-margins">        
            <ul class="website-footer__links website-footer__links--footer">
              <li><a href="https://www.upenn.edu/">UPenn</a></li>
              <li><a href="https://www.upenn.edu/about/privacy-policy">Privacy Policy</a></li>
              <li><a href="https://accessibility.web-resources.upenn.edu/get-help">Report Accessibility Issues and Get Help</a></li>
              <li><a href="https://www.upenn.edu/about/disclaimer">Disclaimer</a></li>
              <li><a href="https://www.publicsafety.upenn.edu/contact/">Emergency Services</a></li>
              <li><a href="https://www.upenn.edu/about/report-copyright-infringement">Report Copyright Infringement</a></li>
            </ul>
          </div>
        </div>
      </footer>
    );
  }
}
